import { recordsFor } from './engine';

// Bridge existing BOS forms to the durable queue. Only explicitly supported
// shapes enter it; do not queue arbitrary HTTP requests (uploads/actions/etc.).
export async function saveLegacy(engine, method, url, body) {
  const route = url.replace(/^\//, '').split('?')[0];
  const state = await engine.read();
  if (method === 'PATCH' && ['coreSeqV6/single', 'coreSeqV5/single'].includes(route)) {
    const path = `${String(body.elementPath).replace(/^\/+|\/+$/g, '')}/${body.documentId}`;
    const entry = Object.entries(state.packages).find(([key]) => recordsFor(state, key).some(r => r.path === path));
    if (!entry) return null;
    const item = await engine.save(entry[0], path, { [body.key]: body.value });
    return { status: 200, success: true, message: 'Enregistré sur cet appareil', offlineSaved: true, operationId: item?.op.id };
  }
  if (method === 'POST' && ['coreSeqV6', 'coreSeqV5'].includes(route) && body.structureId && body.data) {
    const entry = Object.entries(state.packages).find(([, pack]) => pack.manifest.selection.structureId === body.structureId);
    if (!entry) return null;
    // Never silently drop unsupported values from a normal creation form.
    if (body.tags?.length || body.groups?.length || body.blockIdentifiant) throw new Error('ACTION_ONLINE_ONLY');
    const values = { ...body.data, name: body.name || body.data.name };
    const dependencyId = values.dependencyId || null;
    delete values.dependencyId;
    const caps = entry[1].manifest.capabilities;
    for (const key of Object.keys(values)) {
      if (values[key] === null || values[key] === undefined || values[key] === '') { if (!caps.fields.some(f => f.key === key)) delete values[key]; }
    }
    const item = await engine.save(entry[0], null, values, dependencyId);
    return { status: 200, message: 'Enregistré sur cet appareil', offlineSaved: true, operationId: item.op.id,
      elementId: `local:${item.op.id}`, elementPath: `local:${item.op.id}` };
  }
  return null;
}
